import React from 'react';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';

type ImagePartProps = {
  tabsContent: {
    id: number;
    title: string;
    description: string;
    img: string;
    mobileImg: string;
  }[];
  selectedTab: number;
};
export const ImagePart = ({ tabsContent, selectedTab }: ImagePartProps) => {
  return (
    <div className="max-lg:h-screen max-lg:mb-8 max-lg:mt-5 max-lg:w-screen md:rounded-xl relative w-full flex justify-center max-lg:max-h-[316px] lg:min-h-[28.125vw]">
      {tabsContent.map((item, index) => (
        <div key={item.id} className="h-full w-auto absolute">
          <motion.div
            className="h-full"
            animate={{
              opacity: selectedTab === index ? 1 : 0,
            }}
            transition={{ duration: 0.6 }}
          >
            <picture className={clsx('w-full h-full object-contain')}>
              <source srcSet={item.img} media="(min-width: 1024px)" />
              <img
                className="h-full w-full object-contain object-center"
                src={item.mobileImg}
                alt={`${item.title} image`}
              />
            </picture>
          </motion.div>
        </div>
      ))}
    </div>
  );
};
